import { render, staticRenderFns } from "./jingwai.vue?vue&type=template&id=6750b0f2"
import script from "./jingwai.vue?vue&type=script&lang=js"
export * from "./jingwai.vue?vue&type=script&lang=js"
import style0 from "./jingwai.vue?vue&type=style&index=0&id=6750b0f2&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports